import {Answer} from '@/state/models/Answer';

export class AssessmentHistory {
    public id: number = 0;
    public timestamp: Date = new Date();
    public assessmentId: number | null = null;
    public studentId: number | null = null;
    public answerMap: Map<number, Answer> = new Map<number, Answer>();

    constructor(timestamp: Date, assessmentId: number, studentId: number, answerMap: Map<number, Answer>, id?: number) {
        this.id = id || 0;
        this.timestamp = timestamp;
        this.assessmentId = assessmentId;
        this.studentId = studentId;
        this.answerMap = answerMap;
    }

    public countPercentageCorrect() {
        let count = 0;
        let values = Array.from(this.answerMap.values());
        for (let i = 0; i < values.length; i++) {
            if (values[i].isCorrect()) {
                count++;
            }
        }
        const percent = ((count / this.answerMap.size) * 100);
        return percent.toFixed(2);
    }
}
